import React, { useEffect } from 'react';
import { withRouter, Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import configs from '../../config/circular.json';
import WebLayout from '../../layouts/WebLayout';
import PageNotFound from '../../modules/common/PageNotFound';

import CircularListPanel from './CircularListPanel';
import CircularContent from './CircularContent';
import AMLListPanel from './AMLListPanel';


const DownloadFilePage = ({ getApiUrl, docUrlBuilder }) => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // Build API URL for download (provided as a prop)
    const apiUrl = getApiUrl(params, location);

    // Build the doc page URL as the "back" destination
    const docUrl = docUrlBuilder(params, location);

    // Replace history to prevent download loop on "back"
    history.replace(docUrl);

    // Trigger download
    window.location = apiUrl;
  }, [params, location, history, getApiUrl, docUrlBuilder]);

  return (
    <div>
      <p>Your download should start automatically.<br />
        <a href="#" onClick={() => history.goBack()}>Go back</a>
      </p>
    </div>
  );
};


function CircularRoute(props) {

    const { i18n } = useTranslation();
    const { match } = props;

    const toList = (props) => {
        const { params } = props.match;

        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== undefined) {
            i18n.setDefaultNamespace('circular');

            let listPanel;
            if ( "anti-money-laundering" === cfg.category ) {
                listPanel = AMLListPanel;
            } else {
                listPanel = CircularListPanel;
            }

            return (
                <WebLayout component={listPanel}
                    i18ns="circular" sectionId={cfg.sectionId} pageId={cfg.pageId}
                    category={cfg.category} postDocType={cfg.postDocType}/>
            );
        } else {
            return (<p>404!</p>)
        }
    };

    const toContent = (props) => {
        const { params } = props.match;
        
        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== undefined) {
            const params = new URLSearchParams(props.location.search);
            const refNo = params.get('refNo');
            i18n.setDefaultNamespace('circular');
            
            return (
                <WebLayout component={CircularContent} refNo={refNo}
                    sectionId={cfg.sectionId} pageId={cfg.pageId}/>
            );
        } else {
            return (<p>404!</p>)
        }
    };

    const openFile = (props) => {
      // Helper to construct API URL
      const getApiUrl = (params, location) => {
        const urlParams = new URLSearchParams(location.search);
        const apiParams = new URLSearchParams();
        apiParams.set("lang", params.lang);
        apiParams.set("refNo", urlParams.get("refNo"));
        return `${process.env.PUBLIC_URL}/api/circular/openFile?${apiParams}`;
      };

      // Helper to construct doc page URL
      const docUrlBuilder = (params, location) => {
        const urlParams = new URLSearchParams(location.search);
        return `/gateway/${params.lang}/circular/doc?refNo=${urlParams.get("refNo")}`;
      };

      // Render the download component
      return <DownloadFilePage getApiUrl={getApiUrl} docUrlBuilder={docUrlBuilder} />;
    };

    const openAppendix = (props) => {
      // Helper to construct API URL
      const getApiUrl = (params, location) => {
        const urlParams = new URLSearchParams(location.search);
        const apiParams = new URLSearchParams();
        apiParams.set("lang", params.lang);
        apiParams.set("refNo", urlParams.get("refNo"));
        apiParams.set("appendix", urlParams.get("appendix"));
        return `${process.env.PUBLIC_URL}/api/circular/openAppendix?${apiParams}`;
      };

      // Helper to construct doc page URL
      const docUrlBuilder = (params, location) => {
        const urlParams = new URLSearchParams(location.search);
        return `/gateway/${params.lang}/circular/doc?refNo=${urlParams.get("refNo")}`;
      };

      // Render the download component
      return <DownloadFilePage getApiUrl={getApiUrl} docUrlBuilder={docUrlBuilder} />;
    };

    return (
        
        <Switch>
            <Route path={`${match.path}:urlPath*/doc`} 
                render={toContent}/>
            <Route path={`${match.path}:urlPath*/openFile`}
                render={openFile}/>
            <Route path={`${match.path}:urlPath*/openAppendix`} 
                render={openAppendix}/>
            <Route path={`${match.path}:urlPath*/`} 
                strict exact render={toList}/>
        </Switch>
    );
}

export default withRouter(CircularRoute);